import actions from './actions';
import types from './mutation-types';

const state = {
	pendingBids: {
		error: null,
		isFetching: false,
		data: [],
		meta: {
			currentPage: 1,
			totalItems: null,
			totalPages: null
		}
	},
	delete: {
		isDeleting: false,
		error: null
	},
	bid: {}
};

const getters = {
	pendingBidsIsFetching: state => state.pendingBids.isFetching,
	pendingBids: state => state.pendingBids,
	isDeleting: state => state.delete.isDeleting
};

const mutations = {
	[types.FETCH_PENDING_BIDS_START](state) {
		state.pendingBids.isFetching = true;
	},
	[types.FETCH_PENDING_BIDS_ERROR](state, error) {
		state.pendingBids.isFetching = false;
		state.pendingBids.error = error;
	},
	[types.FETCH_PENDING_BIDS_SUCCESS](state, data) {
		state.pendingBids.isFetching = false;
		state.pendingBids.error = null;
		state.pendingBids.data = data.pendingBids;
		state.pendingBids.meta = data.meta;
	},
	[types.DELETE_BID_START](state) {
		state.delete.isDeleting = true;
		state.delete.error = null;
	},
	[types.DELETE_BID_SUCCESS](state) {
		state.delete.isDeleting = false;
		state.bid = {};
	},
	[types.DELETE_BID_ERROR](state, payload) {
		state.delete.isDeleting = false;
		state.delete.error = payload;
	}
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/pending-bid-list/index.js